// @ts-check
"use strict"

/** @param {string} userEmail */
export function isUserWhitelistedForModelParamsControls(userEmail) {
  if(userEmail?.endsWith("@minohealth.org")) return true
  return USERS_WHITE_LIST.includes(userEmail)
}

const USERS_WHITE_LIST = [
  "nanayeb34@gmail.com", 
  "andrews.kangah@minohealth.org", 
  "donald.asiedu@minohealth.org",
  "andyata24.ak@gmail.com",
  "kwabena.fuachie@minohealth.org",
  "minohealthai@gmail.com",
  "karaagroai@gmail.com",
  "jeremiah.ayensu@minohealth.org",
  "uthmant14@gmail.com",
  "joshuaopareboateng@gmail.com",
  "solomon@minohealth.org",
  "nyarko@minohealth.org",
  "mino7mecha@gmail.com",
];

export const MODEL_PARAMS_FORM_ID = "model-params-form"

export function validateModelParams() {
  const form = document.querySelector(`#${MODEL_PARAMS_FORM_ID}`)
  if(!(form instanceof HTMLFormElement)) return false
  const isValid = form.checkValidity()

  if(!isValid) {
    const detailsEl = form.closest("details")
    if(!(detailsEl instanceof HTMLDetailsElement)) return false
    detailsEl.open = true
    form.reportValidity()
  }
  
  return isValid
}